import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { ItemServicoAgendamento } from 'src/app/admihair/api/dto/item-servico-agendamento';
import { PageRequest } from 'src/app/admihair/api/dto/paginacao/page-request';
import { PageResponse } from 'src/app/admihair/api/dto/paginacao/page-response';
import { DialogPaginadoBaseComponent } from 'src/app/admihair/components/shared/dialogs/dialog-paginado-base.component';
import { ItemServicoAgendamentoService } from 'src/app/admihair/service/item-servico-agendamento.service';

@Component({
  selector: 'app-select-servico-agendamento-dialog',
  templateUrl: './select-servico-agendamento-dialog.component.html',
  styleUrls: ['./select-servico-agendamento-dialog.component.scss']
})
export class SelectServicoAgendamentoDialogComponent extends DialogPaginadoBaseComponent<ItemServicoAgendamento> {

  @Input() profissionalId?: number;
  @Output() selecionar = new EventEmitter<ItemServico>();

  constructor(private itemServicoService: ItemServicoAgendamentoService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  selecionarItem(item: ItemServicoAgendamento) {
    this.selecionar.emit(item);
    this.fechar();
  }

  abrirJanelaResumo(item: ItemServicoAgendamento) {
    const url = `${window.location.origin}/#/janela-empresa/item-servico-detalhe/${item.id}`;
    const newWindow = window.open(url, '_blank', 'width=800,height=600,menubar=no,toolbar=no,location=no,status=no');
    if (newWindow) {
      newWindow.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          newWindow.close();
        }
      });
    }
  }

  protected override buscarPagina(busca: string | undefined, pageRequest: PageRequest): Observable<PageResponse<ItemServicoAgendamento>> {
    
    return this.itemServicoService.listarAgendaveis(
      this.profissionalId!,
      busca,
      pageRequest
    );
  }

  protected override get ordenacaoPadrao(): string {
    return 'descricao';
  }

}
